import React from "react";
import { Button, CircularProgress } from "@material-ui/core";
import { useDirectDepositDownloadHandler } from "./Hooks/useDirectDepositDownloadHandler";
import { usePartnerConfig } from "Hooks/usePartnerConfig";
import useStyles from "./styles";
import DirectDepositWarningModal from "./DirectDepositUpdateWarningModal/DirectDespositWarningModal";

type Props = {
  pendingCount: number;
  refetch: () => void;
};

const DirectDepositUpdateButton = ({ pendingCount, refetch }: Props) => {
  const classes = useStyles();
  const [state, setState] = React.useState({
    showSpinner: false,
    isModalOpen: false,
  });
  const { permissions } = usePartnerConfig();
  const {
    onButtonClickHandler
  } = useDirectDepositDownloadHandler(
    permissions.canCreateDirectDepositUpdateFiles
  );

  const onModalToggle = () => {
    setState({ ...state, isModalOpen: !state.isModalOpen });
  };

  const onConfirmClickHandler = async () => {
    try {
      setState({ isModalOpen: false, showSpinner: true });
      await onButtonClickHandler();
      refetch();
    } finally {
      setState({ isModalOpen: false, showSpinner: false });
    }
  };

  return (
    <>
      <Button
        className={classes.button}
        color="primary"
        disabled={pendingCount ? false : true}
        variant="contained"
        onClick={
          permissions.canCreateDirectDepositUpdateFiles
            ? onModalToggle
            : onConfirmClickHandler
        }
        component="a"
      >
        {state.showSpinner ? (
          <CircularProgress size={30} className={classes.loadingSpinner} />
        ) : (
          "Download Updates"
        )}
      </Button>
      <DirectDepositWarningModal
        isOpen={state.isModalOpen}
        onCancelClick={onModalToggle}
        onConfirmClick={onConfirmClickHandler}
      />
    </>
  );
};

export default DirectDepositUpdateButton;
